export default __webpack_public_path__ + "static/media/ui-des.1de7b93e.png";